<div class="modal-header">
  <h4 class="modal-title" id="modal-title">{{ mainTitle }}</h4>
  <button
    type="button"
    class="close text-primary"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
    >
    <i class="fas fa-times-circle"></i>
  </button>
</div>
<div class="modal-body">
  <p>
    {{ mainMessage }}
  </p>
  @if (errorMessage) {
    <ngb-alert type="danger" (close)="errorMessage = ''">{{
      errorMessage
    }}</ngb-alert>
  }
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-secondary"
    (click)="activeModal.dismiss('cancel click')"
    >
    Aceptar
  </button>
</div>
